import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationCategory  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationCategory.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Description = null;
this.Type = null;
this.Method = null;
this.PeriodType = null;
this.MarginalSalvageValue = null;
this.SalvageValue = null;
this.UsefulLife = null;
this.MaximumPurchaseValueForTotalDepreciation = null;
this.PercentageSalvageValueForTotalDepreciation = null;
this.DepreciationDuration = null;
this.MonthStartType = null;
this.MonthThreshold = 15;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
Type:any;
Method:any;
PeriodType:any;
MarginalSalvageValue:any;
SalvageValue:any;
UsefulLife:any;
MaximumPurchaseValueForTotalDepreciation:any;
PercentageSalvageValueForTotalDepreciation:any;
DepreciationDuration:any;
MonthStartType:any;
MonthThreshold:any;
DepreciationRate:any;
static setDepreciationRate = ($this, value) => {
var oldValue = $this.DepreciationRate;
$this.DepreciationRate = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}